module.exports = __webpack_public_path__ + "images/notifications/report@2x-0c7ba2d33cff626fcb6db0ce8b773278.png";